import { render, staticRenderFns } from "./LeaderboardMobile.vue?vue&type=template&id=ede2f67e&scoped=true&"
import script from "./LeaderboardMobile.vue?vue&type=script&lang=js&"
export * from "./LeaderboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardMobile.vue?vue&type=style&index=0&id=ede2f67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede2f67e",
  null
  
)

export default component.exports